/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { CoachButton } from 'bundles/ai-coach-platform/components/building-blocks';

type Props = {
  message: string;
  onClick: (message: string) => void;
};

const styles = {
  container: css`
    margin-bottom: var(--cds-spacing-100);
  `,
};

const QuickMessageV2 = ({ message, onClick }: Props) => {
  return (
    <div css={styles.container}>
      <CoachButton variant="secondary" size="medium" fullWidth={false} onClick={() => onClick(message)}>
        {message}
      </CoachButton>
    </div>
  );
};

export default QuickMessageV2;
